export default function Sky() {
  return (
    <>
      <p align="left">
        <a class="1" href="/">
          main
        </a>
        {' > '}
        <a class="1" href="/art">
          art
        </a>
        {' > '}
        <a class="1" href="/photos/">
          photography
        </a>
        {' > '}
        <a class="1" href="/photos/sky">
          sky
        </a>
      </p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/sky/breachingsun.jpg" target="_blank">
                <img
                  src="/assets/photo/sky/breachingsun_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Breaching Sun
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/sky/dawnofhope.jpg" target="_blank">
                <img
                  src="/assets/photo/sky/dawnofhope_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Dawn of Hope
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/sky/hopelessafternoon.jpg" target="_blank">
                <img
                  src="/assets/photo/sky/hopelessafternoon_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Hopeless Afternoon
              </a>{' '}
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/sky/hopelessdawn.jpg" target="_blank">
                <img
                  src="/assets/photo/sky/hopelessdawn_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Hopeless Dawn
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/sky/inredfields.jpg" target="_blank">
                <img
                  src="/assets/photo/sky/inredfields_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                In Red Fields
              </a>{' '}
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/sky/last_hope.jpg" target="_blank">
                <img
                  src="/assets/photo/sky/last_hope_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Last Hope
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/sky/lonesome_cow.jpg" target="_blank">
                <img
                  src="/assets/photo/sky/lonesome_cow_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Lonesome Cow
              </a>{' '}
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/sky/newbornsun.jpg" target="_blank">
                <img
                  src="/assets/photo/sky/newbornsun_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Newborn Sun
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/sky/say_goodbye_to_the_sun.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/sky/say_goodbye_to_the_sun_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Say Goodbye to the Sun
              </a>{' '}
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/sky/say_goodbye_to_the_sun_2.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/sky/say_goodbye_to_the_sun_2_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Say Goodbye to the Sun 2
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/sky/the_clouds_are_attacking.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/sky/the_clouds_are_attacking_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />T he Clouds are Attacking
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/sky/the_rising_of_the_evil_tree.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/sky/the_rising_of_the_evil_tree_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                The Rising of the Evil Tree
              </a>
            </div>
          </td>
        </tr>
      </table>
    </>
  );
}
